import * as React from "react";

/**
 * On/off toggle. Controlled (checked + onChange) or uncontrolled (defaultChecked).
 */
export interface SwitchProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  size?: "sm" | "md";
  /** Accessible name when there is no visible label */
  label?: string;
}

export function Switch({
  checked,
  defaultChecked = false,
  onChange,
  size = "md",
  label,
  className,
  ...rest
}: SwitchProps): JSX.Element {
  const [inner, setInner] = React.useState(defaultChecked);
  const on = checked === undefined ? inner : checked;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      className={["gk-switch", size === "sm" && "gk-switch--sm", className].filter(Boolean).join(" ")}
      onClick={() => {
        if (checked === undefined) setInner(!on);
        onChange?.(!on);
      }}
      {...rest}
    />
  );
}
